export default __webpack_public_path__ + "assets/heart-beating-component.381b387e.svg";